import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Deletes a cashier user by ID using the centralized API call function.
 * 
 * @param {string} cashierId - The unique ID of the cashier to be deleted.
 * @returns {Object} - The response data from the server after deletion.
 * @throws {Error} - If the request fails or the response is not ok.
 * 
 * @author Susovan Mishra
 */
const deleteCashier = async (cashierId) => {
  return await apiCall(`${AUTH_ROUTES.USERS_API_ENDPOINT}/${encodeURIComponent(cashierId)}`, {
    method: "DELETE",
  });
};

export default deleteCashier;
